import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component( {
    selector: 'app-footer',
    templateUrl: './footer.component.html'
} )

export class FooterComponent {

    today: number = Date.now();

    version: string = environment.version;

    constructor() {
    }
}
